module.exports = __webpack_public_path__ + "img/1.368f8fb8.png";